import { SVGProps } from 'react'

export const CategoryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_4492_988"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="20"
      height="20"
    >
      <path
        d="M2.8334 10.3324C2.61237 10.3324 2.40039 10.2446 2.2441 10.0883C2.0878 9.93197 2 9.71999 2 9.49896V2.8334C2 2.61237 2.0878 2.40039 2.2441 2.2441C2.40039 2.0878 2.61237 2 2.8334 2H9.50063C9.72166 2 9.93364 2.0878 10.0899 2.2441C10.2462 2.40039 10.334 2.61237 10.334 2.8334V9.49896C10.334 9.71999 10.2462 9.93197 10.0899 10.0883C9.93364 10.2446 9.72166 10.3324 9.50063 10.3324H2.8334ZM14.501 10.3324C14.28 10.3324 14.068 10.2446 13.9117 10.0883C13.7554 9.93197 13.6676 9.71999 13.6676 9.49896V2.8334C13.6676 2.61237 13.7554 2.40039 13.9117 2.2441C14.068 2.0878 14.28 2 14.501 2H21.1666C21.3876 2 21.5996 2.0878 21.7559 2.2441C21.9122 2.40039 22 2.61237 22 2.8334V9.49896C22 9.71999 21.9122 9.93197 21.7559 10.0883C21.5996 10.2446 21.3876 10.3324 21.1666 10.3324H14.501ZM2.8334 22C2.61237 22 2.40039 21.9122 2.2441 21.7559C2.0878 21.5996 2 21.3876 2 21.1666V14.4994C2 14.2783 2.0878 14.0664 2.2441 13.9101C2.40039 13.7538 2.61237 13.666 2.8334 13.666H9.50063C9.72166 13.666 9.93364 13.7538 10.0899 13.9101C10.2462 14.0664 10.334 14.2783 10.334 14.4994V21.1666C10.334 21.3876 10.2462 21.5996 10.0899 21.7559C9.93364 21.9122 9.72166 22 9.50063 22H2.8334ZM14.501 22C14.28 22 14.068 21.9122 13.9117 21.7559C13.7554 21.5996 13.6676 21.3876 13.6676 21.1666V14.4994C13.6676 14.2783 13.7554 14.0664 13.9117 13.9101C14.068 13.7538 14.28 13.666 14.501 13.666H21.1666C21.3876 13.666 21.5996 13.7538 21.7559 13.9101C21.9122 14.0664 22 14.2783 22 14.4994V21.1666C22 21.3876 21.9122 21.5996 21.7559 21.7559C21.5996 21.9122 21.3876 22 21.1666 22H14.501Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask0_4492_988)">
      <rect y="-0.000976562" width="24" height="24" fill="#455671" />
    </g>
  </svg>
)
